var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccommodation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73531 10.0299V15.1634C6.73531 16.5064 6.73531 17.1778 6.99666 17.6908C7.22655 18.142 7.59338 18.5088 8.04458 18.7386C8.1652 18.8001 8.29459 18.8471 8.43942 18.8831M8.43942 18.8831C8.85358 17.1175 10.4384 15.8028 12.3304 15.8028C14.2223 15.8028 15.8071 17.1175 16.2213 18.8831M8.43942 18.8831C8.91045 19 9.54479 19 10.5719 19H14.0888C15.1159 19 15.7503 19 16.2213 18.8831M19.524 11.8063L15.1813 6.9818C14.1936 5.88455 13.6998 5.33593 13.1182 5.13339C12.6074 4.9555 12.0514 4.95554 11.5406 5.13351C10.959 5.33613 10.4653 5.88483 9.4778 6.98222L5.13672 11.8063M17.9254 6.2113V15.1634C17.9254 16.5064 17.9254 17.1778 17.6641 17.6908C17.4342 18.142 17.0674 18.5088 16.6162 18.7386C16.4956 18.8001 16.3662 18.8471 16.2213 18.8831M13.929 11.8063C13.929 12.6892 13.2133 13.4049 12.3304 13.4049C11.4475 13.4049 10.7318 12.6892 10.7318 11.8063C10.7318 10.9234 11.4475 10.2078 12.3304 10.2078C13.2133 10.2078 13.929 10.9234 13.929 11.8063Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccommodation);
export default __webpack_public_path__ + "static/media/accommodation.db0e91ed290c0080b7367f2dd21f6235.svg";
export { ForwardRef as ReactComponent };